<template>
  <div class="app-container">
    <!--查询组-->
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item prop="search">
          <el-input
            v-model="listQuery.search"
            placeholder="请输入用户名称"
            clearable
            @keyup.enter.native="SearchData"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button
          v-auth="'Account.create'"
          class="action-item"
          type="primary"
          icon="el-icon-edit"
          @click="HandleCreate"
        >
          添加
        </el-button>
        <el-button
          v-auth="'Account.delete'"
          class="action-item"
          icon="el-icon-delete"
          @click="BatchDelete"
        >
          删除
        </el-button>
      </el-button-group>
    </div>
    <!--表开始-->
    <el-table
      ref="singleTable"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
    >
      <el-table-column type="selection" />
      <el-table-column align="center" label="编号" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="username"
        label="用户名"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        prop="role_name"
        label="角色"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          {{ row.roles_name }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        align="center"
        prop="unit_name"
        label="单位"
        show-overflow-tooltip
        width="200"
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.unit_name == '' || row.unit_name == null">
            无
          </el-tag>
          <el-tag v-else type="success">
            {{ row.unit_name }}
          </el-tag>
        </template>
      </el-table-column> -->
      <el-table-column
        align="left"
        prop="realname"
        label="真实名称"
        width="180"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        label="状态"
        width="100"
        column-key="status"
        prop="status"
        :filters="[{ text: '启用', value: 1 }, { text: '禁用', value: 0 }]"
        :filter-method="filterHandler"
      >
        <template slot-scope="{ row }">
          <el-switch
            v-model="row.status"
            :active-value="1"
            :inactive-value="0"
            @change="changeState(row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="prev_login_time"
        width="180"
        label="上次登录时间"
      />
      <el-table-column
        align="center"
        prop="create_time"
        width="180"
        label="创建时间"
      />
      <el-table-column align="center" prop="" label="操作" width="320">
        <template slot-scope="scopes">
          <el-button
            v-auth-all="['Account.edit', 'Account.reset_password']"
            type="warning"
            icon="el-icon-refresh"
            size="mini"
            @click="resetPwd(scopes.row)"
          >
            重置密码
          </el-button>
          <el-button
            v-auth="'Account.edit'"
            type="primary"
            icon="el-icon-edit"
            size="mini"
            @click="HandleUpdate(scopes.row)"
          >
            编辑
          </el-button>
          <el-button
            v-auth="'Account.delete'"
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="RowDelete(scopes.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="loadData"
    />
    <!--弹窗编辑/新增窗体-->
    <el-dialog
      :title="dialogStatus == 'create' ? '新增' : '编辑'"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-position="left"
        label-width="100px"
        style="width: 400px; margin-left:50px;"
      >
        <el-form-item label="角色" prop="roles">
          <el-select v-model="temp.roles" placeholder="请选择角色" multiple>
            <el-option
              v-for="(item, index) in role"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="所属部门" props="depts">
          <treeselect
            v-model="temp.depts"
            :options="deptOptions"
            :normalizer="normalizer"
            multiple
            flat
            placeholder="选择所属部门"
          />
        </el-form-item>

        <el-form-item label="登录用户名" prop="username">
          <el-input
            v-model="temp.username"
            :disabled="dialogStatus != 'create'"
          />
        </el-form-item>
        <el-form-item label="真实姓名" prop="realname">
          <el-input v-model="temp.realname" />
        </el-form-item>
        <template v-if="dialogStatus == 'create'">
          <el-form-item label="密码" prop="password">
            <el-input v-model="temp.password" type="password" />
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmpassword">
            <el-input v-model="temp.confirmpassword" type="password" />
          </el-form-item>
        </template>
        <el-form-item label="状态" prop="status">
          <el-radio v-model="temp.status" :label="1" border>
            启用
          </el-radio>
          <el-radio v-model="temp.status" :label="0" border>
            禁用
          </el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="ConfirmData">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/account' // 和数据交互相关写在api 方便复用
import role from '@/api/role' // 和数据交互相关写在api 方便复用
import { listDept } from '@/api/department'
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import { mapGetters } from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'AccountList',
  components: { Pagination, Treeselect },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.temp.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      // api接口方法
      api,
      role,
      // 部门树选项
      deptOptions: [],
      // 校验
      rules: {
        roles: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        username: [
          { required: true, message: '请输入登录用户名', trigger: 'blur' }
        ],
        realname: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9]+$/,
            required: true,
            message: '数字或英文，不包含特殊字符',
            trigger: 'blur'
          }
        ],
        confirmpassword: [{ validator: validatePass2, trigger: 'blur' }]
      },
      temp: {}
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  created() {
    this.loadData() // 页面加载创建时加载数据
    this.loadModule()
    // this.loadunit()
  },
  methods: {
    /** 转换部门数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.id,
        label: node.name,
        children: node.children
      }
    },
    // 获取角色
    loadModule() {
      this.role.getAll().then(response => {
        this.role = response.data
      })
    },
    // 更新状态
    changeState(row) {
      this.api.SaveSimple({ id: row.id, status: row.status }).then(response => {
        this.$notify({
          title: '成功',
          message: response.message,
          type: 'success'
        })
      })
    },
    resetTemp() {
      this.temp = { id: undefined, status: 1 }
    },
    // 筛选
    filterHandler(value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    // 重置密码
    resetPwd(row) {
      this.$prompt('请输入重置密码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[a-zA-Z0-9]+$/,
        inputErrorMessage: '数字或英文，不包含特殊字符',
        inputType: 'password'
      })
        .then(({ value }) => {
          this.api.ResetPwd({ id: row.id, password: value }).then(response => {
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success'
            })
            if (this.current_user.id === row.id) {
              this.$alert('修改密码成功请您重新登录', '系统提示', {
                confirmButtonText: '确定',
                showClose: false,
                callback: action => {
                  this.logout()
                }
              })
            }
          })
        })
        .catch(() => {})
    },
    async logout() {
      //  退出登录
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.path}`)
    },
    getDeptTree() {
      listDept().then(response => {
        this.deptOptions = response.data
      })
    },
    // 显示添加窗体
    HandleCreate() {
      this.getDeptTree()
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
    },
    // 显示编辑窗体
    HandleUpdate(row) {
      this.getDeptTree()
      const temp = JSON.parse(JSON.stringify(row))
      if (temp.roles) {
        temp.roles = temp.roles.split(',').filter(i => i !== '').map(i => parseInt(i))
      } else {
        temp.roles = []
      }

      if (temp.depts) {
        temp.depts = temp.depts.split(',').filter(i => i !== '').map(i => parseInt(i))
      } else {
        temp.depts = []
      }

      this.temp = temp
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
    },
    // 提交（确定）
    ConfirmData() {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          const formData = JSON.parse(JSON.stringify(this.temp))
          formData.type = this.type

          if (formData.depts && formData.depts.length > 0) {
            formData.depts = formData.depts.join(',')
          } else {
            formData.depts = ''
          }

          if (formData.roles && formData.roles.length > 0) {
            formData.roles = formData.roles.join(',')
          } else {
            formData.roles = ''
          }

          if (this.dialogStatus === 'create') {
            api.Create(formData).then(() => {
              this.loadData()
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '操作成功',
                type: 'success',
                duration: 2000
              })
            })
          } else {
            api.Update(formData).then(() => {
              this.loadData()
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '操作成功',
                type: 'success',
                duration: 2000
              })
            })
          }
        }
      })
    }
  }
}
</script>
